import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  visitorID: "",
  visitorProfile: [],
};

const profileReducer = createSlice({
  name: "profileData",
  initialState,
  reducers: {
    setVisitorID: (state, action) => {
      state.visitorID = action.payload;
    },
    setVisitorProfile: (state, action) => {
      state.visitorProfile = action.payload;
    },
  },
});

export const { setVisitorID, setVisitorProfile } = profileReducer.actions;
export default profileReducer.reducer;
